import { Component, Input, Output, EventEmitter } from "@angular/core";
import * as SurveyKo from "survey-knockout";
import * as SurveyCreator from "survey-creator";
import * as widgets from "surveyjs-widgets";
import { init as initCustomWidget } from "./customwidget";
import { Serializer } from 'survey-core';
import * as Survey from 'survey-angular';
import * as katex from 'katex';


widgets.icheck(SurveyKo);
widgets.select2(SurveyKo);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo);
widgets.jqueryuidatepicker(SurveyKo);
widgets.nouislider(SurveyKo);
widgets.select2tagbox(SurveyKo);
//widgets.signaturepad(SurveyKo);
widgets.sortablejs(SurveyKo);
widgets.ckeditor(SurveyKo);
widgets.autocomplete(SurveyKo);
widgets.bootstrapslider(SurveyKo);
//widgets.emotionsratings(SurveyKo);
initCustomWidget(SurveyKo);

SurveyCreator.StylesManager.applyTheme("default");

var CkEditor_ModalEditor = {
  afterRender: function(modalEditor, htmlElement) {
    var editor = window["CKEDITOR"].replace(htmlElement);
    editor.on("change", function() {
      modalEditor.editingValue = editor.getData();
    });
    editor.setData(modalEditor.editingValue);
  },
  destroy: function(modalEditor, htmlElement) {
    var instance = window["CKEDITOR"].instances[htmlElement.id];
    if (instance) {
      instance.removeAllListeners();
      window["CKEDITOR"].remove(instance);
    }
  }
};
SurveyCreator.SurveyPropertyModalEditor.registerCustomWidget(
  "html",
  CkEditor_ModalEditor
);


@Component({
  selector: "survey-creator",
  template: `
    <div id="surveyCreatorContainer">
      <div *ngFor="let question of surveyCreator?.survey?.getAllQuestions()">
        <span [style.color]="'red'" *ngIf="question.isRequired">*</span>
        {{ question.title }}
      </div>
    </div>
  `
})
export class SurveyCreatorComponent {
  surveyCreator: SurveyCreator.SurveyCreator;
  @Input() json: any;
  public equationEditor: SurveyCreator.SurveyQuestionEditorDefinition;
 @Output() surveySaved: EventEmitter<Object> = new EventEmitter();
  ngOnInit() {

    SurveyKo.JsonObject.metaData.addProperty(
     "questionbase",
      "popupdescription:text"
    );
    const starElement = document.createElement('span');
    starElement.textContent = "*";
    starElement.style.color = "red";
   SurveyKo.JsonObject.metaData.addProperty("page", "popupdescription:text");
    SurveyKo.JsonObject
      .metaData.addProperty("question", {
        name: "Marks:Number",
        default: 1,
        minValue: 1,
        maxValue: 20,
        category: "data",
        title: "Marks",
        displayName: "Marks*",
        isRequired: true,
        validators: [
          {
            type: "numeric",
            minValue: 1,
            maxValue: 20
          }
        ]
      });
    SurveyCreator.editorLocalization.getLocale('en').pe.tabs.data = "Data*";
    SurveyCreator.editorLocalization.getLocale('en').pe.tabs.choices = "Choices*";
    //SurveyKo.JsonObject.metaData.removeProperty("question", "name");

    //// Add a new "Name" property to the "general" category
    //SurveyKo.JsonObject.metaData.removeProperty("question", "name");

    //// Add a new "Name" property to the "general" category
    //SurveyKo.JsonObject.metaData.addProperty("question", {
    //  name: "name",
    //  category: "general",
    //  title: "Names",
    //  displayName: "Name*"
    //});

    SurveyKo.JsonObject.metaData.findProperty('question', 'name').displayName = "Name*";
    SurveyKo.JsonObject.metaData.findProperty('question', 'name').isRequired =true;
    const questionProperties = SurveyKo.JsonObject.metaData.getProperties('question');

    console.log(SurveyKo.JsonObject.metaData.findProperty('question', 'marks'));


    questionProperties.forEach(property => {
      // Check if the property is 'name' and it has a value
      if (property.name === 'name' && this.json[property.name]) {
        // Convert the LaTeX to HTML and set it as the title
        this.json[property.name] = this.convertLaTeXToHTML(this.json[property.name]);
      }
    });
    //const questionProperties = SurveyKo.JsonObject.metaData.getProperties('question');

    //questionProperties.forEach(property => {
    //  console.log(property.name);
    //});
    console.log(SurveyKo.JsonObject.metaData.findProperty('survey', 'pages'));
    //console.log(SurveyKo.JsonObject.metaData);
    SurveyKo.JsonObject.metaData.findProperty('question', 'correctAnswer').displayName = "Correct Answer*";
    SurveyKo.JsonObject.metaData.findProperty('question', 'correctAnswer').isRequired = true;
    const surveyMetaData = SurveyKo.JsonObject.metaData;
    console.log(SurveyKo.JsonObject.metaData);

    //const dataSectionProperty = surveyMetaData.findProperty('data', 'name');
    //console.log(dataSectionProperty);
    //dataSectionProperty.displayName = 'Data*';
    //SurveyKo.JsonObject.metaData.findProperty('question', 'defaultValue').displayName = "Default Value*";
    //SurveyKo.JsonObject.metaData.findProperty('question', 'defaultValue').isRequired = true
    //Changes begin here

    //Changes End Here
    

//  // start of quiz properties hiding
  //   SurveyKo.Serializer.removeProperty("survey", "title");
  //   SurveyKo.Serializer.removeProperty("survey", "description");
  //   SurveyKo.Serializer.removeProperty("survey", "mode");
  //   SurveyKo.Serializer.removeProperty("survey", "showTitle");
  //   SurveyKo.Serializer.removeProperty("survey", "locale");
  //   SurveyKo.Serializer.removeProperty("survey", "cookieName");
  //   SurveyKo.Serializer.removeProperty("survey", "showPreviewBeforeComplete");
  //   SurveyKo.Serializer.removeProperty("survey", "pagePrevText");
  //   SurveyKo.Serializer.removeProperty("survey", "pageNextText");
  //   SurveyKo.Serializer.removeProperty("survey", "completeText");
  //   SurveyKo.Serializer.removeProperty("survey", "previewText");
  //   SurveyKo.Serializer.removeProperty("survey", "editText");
  //   SurveyKo.Serializer.removeProperty("survey", "startSurveyText");
  //   SurveyKo.Serializer.removeProperty("survey", "showNavigationButtons");
  //   SurveyKo.Serializer.removeProperty("survey", "showPrevButton");
  //   SurveyKo.Serializer.removeProperty("survey", "firstPageIsStarted");
  //   SurveyKo.Serializer.removeProperty("survey", "goNextPageAutomatic");
  //   SurveyKo.Serializer.removeProperty("survey", "showProgressBar");
  //   SurveyKo.Serializer.removeProperty("survey", "progressBarType");
  //   SurveyKo.Serializer.removeProperty("survey", "questionsOnPageMode");
  //   //SurveyKo.Serializer.removeProperty("survey", "questionTitleLocation");
  //   // SurveyKo.Serializer.removeProperty("survey", "questionDescriptionLocation");
  //   // SurveyKo.Serializer.removeProperty("survey", "showQuestionNumbers");
  //    SurveyKo.Serializer.removeProperty("survey", "questionTitlePattern");
  //    SurveyKo.Serializer.removeProperty("survey", "requiredText");
  //    SurveyKo.Serializer.removeProperty("survey", "questionStartIndex");
  //     SurveyKo.Serializer.removeProperty("survey", "questionErrorLocation");
  //     SurveyKo.Serializer.removeProperty("survey", "focusFirstQuestionAutomatic");
  //     SurveyKo.Serializer.removeProperty("survey", "maxTextLength");
  //     SurveyKo.Serializer.removeProperty("survey", "maxOthersLength");
  //   //  SurveyKo.Serializer.removeProperty("survey", "pages");
  //    SurveyKo.Serializer.removeProperty("survey", "showPageTitles");
  //    SurveyKo.Serializer.removeProperty("survey", "showPageNumbers");
  //    SurveyKo.Serializer.removeProperty("survey", "clearInvisibleValues");
  //   SurveyKo.Serializer.removeProperty("survey", "textUpdateMode");
  //    SurveyKo.Serializer.removeProperty("survey", "sendResultOnPageNext");
  //    SurveyKo.Serializer.removeProperty("survey", "storeOthersAsComment");
  //    SurveyKo.Serializer.removeProperty("survey", "focusOnFirstError");
  //    SurveyKo.Serializer.removeProperty("survey", "checkErrorsMode");
  //    SurveyKo.Serializer.removeProperty("survey", "navigateToUrl");
  //    SurveyKo.Serializer.removeProperty("survey", "showCompletedPage");
  //    SurveyKo.Serializer.removeProperty("survey", "completedHtml");
  //    SurveyKo.Serializer.removeProperty("survey", "navigateToUrlOnCondition");
  //    SurveyKo.Serializer.removeProperty("survey", "completedHtmlOnCondition");
  //    SurveyKo.Serializer.removeProperty("survey", "loadingHtml");
  //    SurveyKo.Serializer.removeProperty("survey", "completedBeforeHtml");
  //    SurveyKo.Serializer.removeProperty("survey", "maxTimeToFinish");
  //    SurveyKo.Serializer.removeProperty("survey", "maxTimeToFinishPage");
  //    SurveyKo.Serializer.removeProperty("survey", "showTimerPanel");
  //    SurveyKo.Serializer.removeProperty("survey", "showTimerPanelMode");
  //    SurveyKo.Serializer
  //    .findProperty("survey", "pages")
  //    .visible = false;
  //   //  SurveyKo.Serializer
  //   //  .findProperty("itemvalue", "Layout")
  //   //  .visible = false;
  // // End of quiz properties hiding

  // // Start of Question type properties hiding
  //   SurveyKo.Serializer.removeProperty("page", "navigationButtonsVisibility");
  //   SurveyKo.Serializer.removeProperty("page", "questionsOrder");
  //   SurveyKo.Serializer.removeProperty("page", "readOnly");
  //   SurveyKo.Serializer.removeProperty("page", "maxTimeToFinish");
  //   SurveyKo.Serializer.removeProperty("page", "questionTitleLocation");
//  // End of quiz properties hiding

//  // Start of Question type properties hiding
//  // end of Question type properties hiding
    let options = { showEmbededSurveyTab: true, generateValidJSON: true };
    this.surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
      options
    );
    this.surveyCreator.text = JSON.stringify(this.json);
    console.log(this.json);
    this.surveyCreator.saveSurveyFunc = this.saveMySurvey;
    
  }
  private convertLaTeXToHTML(latex: string): string {
    try {
      return katex.renderToString(latex, { throwOnError: false });
    } catch (error) {
      console.error("Error rendering LaTeX equation:", error);
      return latex;
    }
  }

  saveMySurvey = () => {    
    this.surveySaved.emit(JSON.parse(this.surveyCreator.text));
    console.log(this.surveyCreator.text);
  };
  
  
}
